module.exports = __webpack_public_path__ + "static/img/PART_01_042028.7d6314d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue14/Down The Jade Mountain/PART_01_042028.jpg
// module id = Wrao
// module chunks = 7